import React from 'react';
import { PaletteMode } from '@mui/material';

export const ColorModeContext = React.createContext({ toggleColorMode: () => {} });
export default ColorModeContext

export const getDesignTokens = (mode: PaletteMode) => ({
    typography: {
        fontFamily: [
            'Geometria',
            'sans-serif'
        ].join(','),
        fontSize: 17,
        letterSpacing: 24,
        h1: {
            fontSize: 32,
        },
        h2: {
            fontSize: 24,
        },
        body1: {
            fontSize: 17,
        },
        body2: {
            fontSize: 17,
        },
        caption: {
            fontSize: 15,
        }
    },
    spacing: 8,
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1180,
            xl: 1536,
        },
    },    
    palette: {
        mode,
        ...(mode === 'light'
            ?   {
                    // palette values for light mode
                    primary: {
                        main: '#6a56cc',
                    },
                    secondary: {
                        main: '#aaaaaa',
                    },
                    error: {
                        main: '#f26d6d',
                        contrastText: '#fff',
                    },
                    success: {
                        main: '#34B778',
                    },
                    disabled: {
                        main: '#f1f1f1',
                    },
                    background: {
                        default: '#f1f1f1',
                        paper: '#fff',
                    },
                }
            :   {
                    // palette values for dark mode
                    primary: {
                        main: '#6a56cc',
                    },
                    secondary: {
                        main: '#6d6d6d',
                    },
                    error: {
                        main: '#F26D6D',
                        contrastText: '#fff',
                    },
                    success: {
                        main: '#34B778',
                    },
                    background: {
                        default: '#353536',
                        paper: '#202020',
                    },
                }
            ),
    },
    shape: {
        borderRadius: 4,
    },
    components: {
        MuiAppBar: {
            defaultProps: {
                color: "default" as "secondary" | "inherit" | "primary" | "default" | "transparent" | undefined,
            },
        },
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    border: 'none',
                    // All row states grey (#F1F1F1) — no purple hover/selected highlight.
                    '& .MuiDataGrid-row:hover': { backgroundColor: '#F1F1F1' },
                    '& .MuiDataGrid-row.Mui-selected': { backgroundColor: '#F1F1F1' },
                    '& .MuiDataGrid-row.Mui-selected:hover': { backgroundColor: '#F1F1F1' },
                },
                cell: {
                    border: 'none',
                    paddingLeft: 32,
                },
                columnHeaderTitleContainer: {
                    //paddingLeft: 32,
                },
                columnSeparator: {
                    display: 'none',
                },
                columnHeader: {
                    paddingLeft: 32,
                    margin: 0
                },
                columnHeaders: {
                    border: 'none',
                },
                cellCheckbox: {
                    padding: 0,
                },
                columnHeaderCheckbox: {
                    padding: 0,
                }
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    height: 48,
                    // Multiline fields (e.g. the add-students names textarea) must grow
                    // with their rows; without this they're pinned to the single-line
                    // height and the content/placeholder overflows the box.
                    '&.MuiInputBase-multiline': {
                        height: 'auto',
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    height: 48,
                    textTransform: "none",
                },
            },
        },
    },
});